import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PDFSection(slice) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function handleClick(page) {
    if (page <= numPages && page >= 1) {
      setPageNumber(page);
    }
  }

  const backgroundStyle = {
    background: slice.primary.background_color,
  };

  const pdfFile = slice.primary.pdf_link.url;

  return (
    <section className="pdf-section standard-padding" style={backgroundStyle}>
      <div className="wrapper">
        <div className="pdf-navigation">
          <p className="page-indicator">
            Page {pageNumber} of {numPages}
          </p>
          <div className="buttons center">
            <a
              className="button"
              onClick={() => {
                handleClick(pageNumber - 1);
              }}
            >
              Previous
            </a>
            <a
              className="button"
              onClick={() => {
                handleClick(pageNumber + 1);
              }}
            >
              Next
            </a>
          </div>
        </div>
        <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
          <Page pageNumber={pageNumber} />
        </Document>
      </div>
    </section>
  );
}
